import React, {useEffect} from 'react';
import {getSponsoredRecommendations} from '../../actions/campaigns';
import {useDispatch, useSelector} from 'react-redux';
import {RecommendationsService, TARGET_ME_KEY} from '../../services/RecommendationsService';
import {followCollege, unfollowCollege} from 'src/actions/studentCollege';
import {Store} from '../../types/store';
import {LoadState} from '../../types/enums';
import {LoadingRecommendationRow} from '../CollegeSearch/LoadingRecommendation';
import SponsoredCollegesRecommendationBucket from '../../views/high-school/TargetMe/ExperimentBucket/SponsoredCollegesRecommendationBucket';
import {setCollegeAppStatus} from 'shared/college-application-status/actions/college-application-status';
import {getBuckets} from '../../actions/recommendations';

const HomepageRecommendationBucket = () => {
  const dispatch = useDispatch();
  const Bucket = useSelector((state: Store) => state.recommendations.buckets);
  const targetMeBucket = Bucket[TARGET_ME_KEY] || {};

  const ShownEventId = useSelector(
    (state: Store) => state.recommendations.recommendationsShownEventId
  );
  const recommendationsShownEventId = ShownEventId || '';
  const collegeApplicationStatuses = useSelector(
    (state: Store) => state.collegeApplicationStatuses
  );
  const user = useSelector((state: Store) => state.collegeSearch.user);
  const isSenior = (user.highSchoolInfo || {}).senior;

  useEffect(() => {
    dispatch(getSponsoredRecommendations(5));
    RecommendationsService.getRecommendationBucketCount().then((limit) =>
      dispatch(getBuckets(limit))
    );
  }, []);

  if (!targetMeBucket) {
    return null;
  }

  return (
    <>
      {targetMeBucket.loadState === LoadState.LOADING ||
        (targetMeBucket.loadState === 0 && (
          <LoadingRecommendationRow rowCount={1} key="home-page-recommendation-loading" />
        ))}
      {targetMeBucket.loadState === LoadState.LOADED && (
        <SponsoredCollegesRecommendationBucket
          key={targetMeBucket.id}
          recommendationBucket={targetMeBucket}
          isSenior={isSenior}
          collegeApplicationStatuses={collegeApplicationStatuses}
          recommendationsShownId={recommendationsShownEventId}
          setCollegeAppStatus={dispatch(setCollegeAppStatus)}
          followCollege={(id) => dispatch(followCollege(id))}
          unfollowCollege={(id) => dispatch(unfollowCollege(id))}
        />
      )}
    </>
  );
};

export default HomepageRecommendationBucket;
